import { IsoIntervalStr } from '@elderbyte/ngx-starter'

export class TimeSchedule {
  /***************************************************************************
   *                                                                         *
   * Static fields                                                           *
   *                                                                         *
   **************************************************************************/

  public static DEFAULT_OFFICE = new TimeSchedule('08:00:00', '17:00:00', 1.0)
  public static DEFAULT_PROD = new TimeSchedule('04:00:00', '23:59:59', 1.0)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor(
    /**
     * Start time
     * 04:00
     */
    public start: string, // LocalTime / IsoTimeStr

    /**
     * End time
     * 17:00
     */
    public end: string, // LocalTime / IsoTimeStr

    /**
     * Performance represented in an interval [0.0 - 1.0] (percent)
     * Note that also more than 100% is possible, i.e. 5.0 = 500%
     */
    public performance: number
  ) {}
}

export class DaySchedule {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor(public timeSchedules: TimeSchedule[] = []) {}
}

export class WeekSchedule {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor(
    public monday = new DaySchedule([TimeSchedule.DEFAULT_PROD]),
    public tuesday = new DaySchedule([TimeSchedule.DEFAULT_PROD]),
    public wednesday = new DaySchedule([TimeSchedule.DEFAULT_PROD]),
    public thursday = new DaySchedule([TimeSchedule.DEFAULT_PROD]),
    public friday = new DaySchedule([TimeSchedule.DEFAULT_PROD]),
    public saturday = new DaySchedule([new TimeSchedule('04:00:00', '12:00:00', 1.0)]),
    public sunday = new DaySchedule()
  ) {}
}

export class WorkSchedule {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor(
    public name: string,
    /**
     * The scope in which this performance schedule is applicable.
     */
    public validityInterval: IsoIntervalStr,
    /**
     * The week schedule
     */
    public weekSchedule: WeekSchedule
  ) {}
}
